import { ComponentProps } from 'react';
import { GlobalStyles, Palette } from '@mui/material';
import { transparentize } from 'polished';

export function getGlobalStyles(palette: Palette): ComponentProps<typeof GlobalStyles>['styles'] {
    return {
        '.MuiDataGrid-root': { background: `${palette.background.paper} !important` },
        '.MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': { display: 'none' },
        '.MuiPickersTextField-root label': { padding: '0 4px' },

        '.MuiBox-root ': {
            '&.calendar': {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                background: palette.divider,
                padding: 1,
                gap: 1,
                '&.workweek': { gridTemplateColumns: 'repeat(5, 1fr)' },
            },
            '&.calendarHeader': {
                padding: '6px 10px',
                background: palette.background.default,
                fontWeight: 'bold',
            },
            '&.calendarCell': {
                minHeight: 150,
                background: palette.common.white,
                '&.closed': { background: palette.grey[200] },
            },
            '&.calendarEntry': {
                background: transparentize(0.95, palette.primary.main),
                borderLeft: 'solid 2px',
                borderLeftColor: palette.primary.main,
                color: palette.primary.main,
                padding: '10px',
                fontSize: '14px',
            },
        },
    };
}
